import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { ConditionalWrapper } from "utils/react";
import BulletCheckedIcon from "./bullet-checked-icon";
import { StyledBullets } from "./bullets.scss";
import DefaultProps from "./default-props";
const Bullets = (props)=>{
    const { bullets, alternativeIcon, bulletsDirection, bulletTextSize, bulletsColor, checkColor } = props;
    const renderBullet = (bullet, bulletIndex)=>{
        const { href, openInNewTab } = bullet;
        const anchorWrapper = (children)=>{
            const target = openInNewTab ? "_blank" : undefined;
            return /*#__PURE__*/ _jsx("a", {
                className: "bullet-anchor-wrapper",
                href: href,
                target: target,
                children: children
            });
        };
        return /*#__PURE__*/ _jsx(ConditionalWrapper, {
            condition: href,
            wrapper: anchorWrapper,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "bullet",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "bullet-icon",
                        children: alternativeIcon || /*#__PURE__*/ _jsx(BulletCheckedIcon, {
                            color: bulletsColor,
                            checkColor: checkColor
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "bullet-text",
                        style: {
                            fontSize: bulletTextSize
                        },
                        children: bullet.bulletText
                    })
                ]
            }, bulletIndex)
        });
    };
    if (!bullets) return null;
    return /*#__PURE__*/ _jsx(StyledBullets, {
        className: classnames("bullets", bulletsDirection),
        children: bullets.map((bullet, bulletIndex)=>{
            return renderBullet(bullet, bulletIndex);
        })
    });
};
Bullets.defaultProps = DefaultProps;
export default Bullets;
